import React, { useCallback, useEffect, useState } from 'react';
import { Row, Card, Radio, Button, Divider } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import SearchBar from '../landingpage/SearchBar';



const AirlineFlightsSearch = () => {
  const navigate = useNavigate()
  const dateFormat = 'DD/MMM/YYYY';
  const currentFormattedDate = dayjs().add(1, 'day').format(dateFormat);
  const nextDay = dayjs().add(2, 'day').format(dateFormat);
  const [findDay, setFindDay] = useState(currentFormattedDate);
  const [findDayRetrun, setFindDayRetrun] = useState(nextDay);

  const [showPrevDateIcon, setShowPrevDateIcon] = useState(null)
  const [selectAdults, setSelectAdults] = useState(1);
  const [selectchildren, setSelectchildren] = useState(0);
  const [selectInfants, setSelectInfants] = useState(0)
  const location = useLocation();
  const [returnFlight, setReturnFlight] = useState("oneWay")
  const [returnFlightComp, setReturnFlightComp] = useState(false);
  const [seatType, setSeatType] = useState("ECONOMY")


  const [errorSameCitySelect, setErrorSameCitySelect] = useState(false)
  const [selectedFrom, setSelectedFrom] = useState("");
  const [selectedTo, setSelectedTo] = useState("");
  const [showSearchListFrom, setShowSearchListFrom] = useState(false);
  const [infantsError, setInFantError] = useState(null)
  const [showSearchListTo, setShowSearchListTo] = useState(false);
  const [topCityData, setTopCityData] = useState(true);
  const [selectFromCity, setselectFromCity] = useState('')
  const [selectFromCityName, setselectFromCityName] = useState('')

  const [selectTOCity, setselectTOCity] = useState('')
  const [selectTOCityName, setselectTOCityName] = useState('')

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isReturnDrawerOpen, setIsReturnDrawerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(currentFormattedDate);
  const [selectedReturnDate, setSelectedReturnDate] = useState(null);

  const handleSelectFromFlight = (flight) => {
    if (flight.cityCode === selectedTo?.cityCode) {
      setErrorSameCitySelect(true);
      return;
    }
    setSelectedFrom(flight);
    setselectFromCity(flight?.city);
    setselectFromCityName(flight?.name);
    setShowSearchListFrom(false);
    setTopCityData(true)
    setShowSearchListTo(true);
  };

  const handleSelectToFlight = (flight) => {
    if (flight.cityCode === selectedFrom?.cityCode) {
      setErrorSameCitySelect(true);
      return;
    }
    setSelectedTo(flight);
    setselectTOCity(flight?.city);
    setselectTOCityName(flight?.name);
    setShowSearchListTo(false);
    setTopCityData(false);
  };


  const addAdults = () => {
    if (selectAdults < 10) {
      setSelectAdults((prevAdults) => {
        const newAdults = prevAdults + 1;
        if (selectInfants <= newAdults) {
          setInFantError(false);
        }
        return newAdults;
      });
    }
  };

  const removeAdults = () => {
    if (selectAdults > 1) {
      setSelectAdults((prevAdults) => {
        const newAdults = prevAdults - 1;
        if (selectInfants > newAdults) {
          setInFantError(true);
        } else {
          setInFantError(false);
        }
        return newAdults;
      });
    }
  };

  const addInfants = () => {
    setSelectInfants((prevSelectInfants) => {
      const newSelectInfants = prevSelectInfants + 1;
      if (newSelectInfants > selectAdults) {
        setInFantError(true);
      } else {
        setInFantError(false);
      }
      return newSelectInfants;
    });
  };



  const removeInfants = () => {
    setSelectInfants((prevSelectInfants) => {
      if (prevSelectInfants > 0) {
        const newSelectInfants = prevSelectInfants - 1;
        if (newSelectInfants > selectAdults) {
          setInFantError(true);
        } else {
          setInFantError(false);
        }
        return newSelectInfants;
      }
      return prevSelectInfants;
    });
  };


  const addChildern = () => {
    if (selectchildren < 10) {
      setSelectchildren(selectchildren + 1);
    }
  }

  const removeChildern = () => {
    if (selectchildren > 0) {
      setSelectchildren(selectchildren - 1);
    }
  }

  const onChangeTrip = (e) => {
    const { value } = e.target;
    setReturnFlight(value);
    setReturnFlightComp(true);
  };

  const roundTrip = () => {
    setReturnFlight("roundTrip");
    setReturnFlightComp(true);
  };

  const crossReturnDate = () => {
    setReturnFlight("oneWay");
    setReturnFlightComp(false);
  }

  const fetchOneWayFlight = useCallback(() => {
    sessionStorage.setItem('selectFromCity', JSON.stringify(selectFromCity));
    sessionStorage.setItem('selectFromCityName', JSON.stringify(selectFromCityName));
    sessionStorage.setItem('selectTOCity', JSON.stringify(selectTOCity));
    sessionStorage.setItem('selectTOCityName', JSON.stringify(selectTOCityName));
    sessionStorage.setItem('DepartureFlight', JSON.stringify(findDay));
    sessionStorage.setItem('selectAdultsflight', JSON.stringify(selectAdults));
    sessionStorage.setItem('selectChildflight', JSON.stringify(selectchildren));
    sessionStorage.setItem('selectInfantsflight', JSON.stringify(selectInfants));
    sessionStorage.setItem('seatTypeflight', JSON.stringify(seatType));
    sessionStorage.setItem('returnFlight', JSON.stringify(returnFlight));
    sessionStorage.setItem('findDayReturnFlight', JSON.stringify(findDayRetrun));
    const formattedFromCity = selectedFrom?.city?.toLowerCase().replace(/\s+/g, '-');
    const formattedToCity = selectedTo?.city?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
    const resultUrl = `/flights/${urlIdDynamic}`;
    navigate(resultUrl);
  }, [selectFromCity, selectFromCityName, selectTOCity, selectTOCityName, findDay, selectAdults, selectchildren, selectInfants, seatType, returnFlight, findDayRetrun, selectedFrom, selectedTo, navigate]);

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    if (!selectedFrom?.cityCode || !selectedTo?.cityCode) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [selectedFrom, selectedTo]);



  const fetchRoundCityFlights = useCallback(() => {
    sessionStorage.setItem('selectFromCity', JSON.stringify(selectFromCity));
    sessionStorage.setItem('selectFromCityName', JSON.stringify(selectFromCityName));
    sessionStorage.setItem('selectTOCity', JSON.stringify(selectTOCity));
    sessionStorage.setItem('selectTOCityName', JSON.stringify(selectTOCityName));
    sessionStorage.setItem('DepartureFlight', JSON.stringify(findDay));
    sessionStorage.setItem('selectAdultsflight', JSON.stringify(selectAdults));
    sessionStorage.setItem('selectChildflight', JSON.stringify(selectchildren));
    sessionStorage.setItem('selectInfantsflight', JSON.stringify(selectInfants));
    sessionStorage.setItem('seatTypeflight', JSON.stringify(seatType));
    sessionStorage.setItem('returnFlight', JSON.stringify(returnFlight));
    sessionStorage.setItem('findDayReturnFlight', JSON.stringify(findDayRetrun));
    const formattedFromCity = selectedFrom?.city?.toLowerCase().replace(/\s+/g, '-');
    const formattedToCity = selectedTo?.city?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
    const resultUrl = `/flights/${urlIdDynamic}`;
    navigate(resultUrl);
  }, [selectFromCity, selectFromCityName, selectTOCity, selectTOCityName, findDay, selectAdults, selectchildren, selectInfants, seatType, returnFlight, findDayRetrun, selectedFrom, selectedTo, navigate]);





  return (
    <section className={location?.pathname !== "/result-page" ? "head-box-cntr head-box-cntr-indigo" : "head-box-cntr-result"} >
      {/* --- Banner Background --- */}
      <picture>
        <source srcSet="/images/flight-video-img.avif" type="image/avif" />
        <img
          src="/images/flight-video-img.avif"
          className="banner_background"
          alt="Banner Background"
          loading="eager"
          fetchpriority="high"
          decoding="async"
          height="330"
          width="1400"
        />
      </picture>

      {/* --- Content Container --- */}
      <div className="Banner_cntr pt-3 pt-md-5">
        <div className="container">
          <Row gutter={16} className='w-100 justify-content-center m-0 d-block'>
            <Card className='bg-white'>

              <div className='d-flex justify-content-between'>
                <Radio.Group
                  defaultValue={returnFlight}
                  value={returnFlight}
                  onChange={onChangeTrip}
                >
                  <Radio value="oneWay">One Way</Radio>
                  <Radio value="roundTrip">Round Trip</Radio>
                </Radio.Group>
              </div>

              <Divider />

              {(returnFlight === "roundTrip" || returnFlight === "oneWay") && (
                <SearchBar
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  selectedReturnDate={selectedReturnDate}
                  setSelectedReturnDate={setSelectedReturnDate}
                  crossReturnDate={crossReturnDate}
                  setReturnFlightComp={setReturnFlightComp}
                  returnFlightComp={returnFlightComp}
                  selectAdults={selectAdults}
                  setSelectAdults={setSelectAdults}
                  selectchildren={selectchildren}
                  setSelectchildren={setSelectchildren}
                  selectInfants={selectInfants}
                  setSelectInfants={setSelectInfants}
                  setReturnFlight={setReturnFlight}
                  returnFlight={returnFlight}
                  removeAdults={removeAdults}
                  addAdults={addAdults}
                  removeInfants={removeInfants}
                  addInfants={addInfants}
                  infantsError={infantsError}
                  removeChildern={removeChildern}
                  addChildern={addChildern}
                  roundTrip={roundTrip}
                  seatType={seatType}
                  setSeatType={setSeatType}
                  findDay={findDay}
                  setFindDay={setFindDay}
                  findDayRetrun={findDayRetrun}
                  setFindDayRetrun={setFindDayRetrun}
                  dateFormat={dateFormat}
                  showPrevDateIcon={showPrevDateIcon}
                  setShowPrevDateIcon={setShowPrevDateIcon}
                  currentFormattedDate={currentFormattedDate}
                  setTopCityData={setTopCityData}
                  topCityData={topCityData}

                  errorSameCitySelect={errorSameCitySelect}
                  setErrorSameCitySelect={setErrorSameCitySelect}
                  selectedFrom={selectedFrom}
                  setSelectedFrom={setSelectedFrom}
                  selectedTo={selectedTo}
                  setSelectedTo={setSelectedTo}
                  showSearchListFrom={showSearchListFrom}
                  setShowSearchListFrom={setShowSearchListFrom}
                  showSearchListTo={showSearchListTo}
                  handleSelectFromFlight={handleSelectFromFlight}
                  handleSelectToFlight={handleSelectToFlight}
                  setShowSearchListTo={setShowSearchListTo}

                  isReturnDrawerOpen={isReturnDrawerOpen}
                  setIsReturnDrawerOpen={setIsReturnDrawerOpen}
                  isDrawerOpen={isDrawerOpen}
                  setIsDrawerOpen={setIsDrawerOpen}
                />
              )}

              <div className='text-center'>
                {returnFlight === "oneWay" ? (
                  <Button type="primary" onClick={fetchOneWayFlight} disabled={isButtonDisabled || infantsError} aria-label="search flights">Search  Flights</Button>
                ) : (
                  returnFlight === "roundTrip" && (
                    <Button type="primary" onClick={fetchRoundCityFlights} disabled={isButtonDisabled || infantsError} aria-label="Search roundtrip flights">Search Flights</Button>
                  )
                )}
              </div>

            </Card>
          </Row>
        </div>
      </div>
    </section >
  );
};

export default AirlineFlightsSearch;
